import { SvgIcon, SvgIconProps } from '@mui/material'

const ArrowDoubleLeftIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon role="img" viewBox="0 0 16 16" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.354 3.646a.5.5 0 0 1 0 .708L4.707 8l3.647 3.646a.5.5 0 0 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 0 1 .708 0Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.354 3.646a.5.5 0 0 1 0 .708L8.707 8l3.647 3.646a.5.5 0 0 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 0 1 .708 0Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export default ArrowDoubleLeftIcon
